<template>
    <b-card no-body>

        <b-modal id="upload" title="Dosya Yükle" body-class="p-75" no-close-on-esc no-close-on-backdrop>
            <bes-upload-file v-model="uploadObject" :upload-errors="uploadErrors"></bes-upload-file>
            <template #modal-footer><v-executer :disabled="!uploadObject.File" :loading="loading" text="Yükle" :action="uploadFile"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :fields="fields"
                    name="bes"
                    :items-provider="provider"
                    pagination="server"
                    :settings="false"
                    search>
                    <template #additional-actions>
                        <div class="row">
                            <div class="col-md-auto">
                                <button class="btn btn-primary w-100" v-on:click="upload">
                                    Dosya Yükle
                                </button>
                            </div>
                        </div>
                    </template>
                    <template #filters>
                        <bes-filter v-on:filter="filter"></bes-filter>
                    </template>
                </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import BesUploadFile from './components/BesUploadFile.vue'
import Additional from '@/utilities/additional'
import EmployeeOperationsApi from '@/api/employee-operations'
import BesFilter from './components/BesFilter.vue'
import moment from 'moment'

export default {
    components:{
        BCard,
        BesUploadFile,
        BesFilter
    },
    data(){
        return{
            loading:false,
            fields:[
                {name:'Personel', key:'EmployeeFullName',thClass:'w-16',tdClass:'text-nowrap'},
                {name:'Kimlik No', key:'IdentityNumber',thClass:'w-14'},
                {name:'Sözleşme No', key:'AgreementNumber',thClass:'w-14'},
                {name:'İşveren Sicil No', key:'EmployerRegistrationNumber',thClass:'w-14'},
                {name:'SGK Şube', key:'SGKBranchName',component:true,componentOptions:{name:"employee-bes-branch/EmployeeBesBranch"},thClass:'w-14'},
                {name:'SGK İş Yeri Sicil No', key:'SGKBranchRegistrationNumber',thClass:'w-14'},
                {name:'Durum Tarihi', key:'StatusDateStr',thClass:'w-14',sortable:true},
                {name:'Durum', key:'Status'},
                //{name:"Güncellik Durum",component:true,componentOptions:{name:"bes-status/BesStatus"},tooltip:'Sorgulanan tarihteki ay için BES bilgisinin yüklenip yüklenmediğinin durmunu gösteririr.'}
            ],
            uploadObject:{
                File:null,
                Month:null,
                Year:null,
            },
            filterData:{
                BranchTypeCode:'O',
                BranchId:null,
                CollarStatusId:null,
                EmployeeId:null,
            },
            uploadErrors:[]
        }
    },
    methods:{
        filter(filter){
            this.filterData = filter
            this.$refs.table.refresh()
        },
        async uploadFile(){
            this.uploadErrors = []
            let formData = await Additional.ToFormData(this.uploadObject,['File'])
            this.loading = true
            EmployeeOperationsApi.Bes.Upload(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Data?.length == 0 && res.data.Success){
                    this.$hideModal('upload')
                    this.$refs.table.refresh()
                }
                else if(res.data.Success){
                    this.$refs.table.refresh()
                    this.uploadErrors = res.data.Data || []
                }else{
                    this.uploadErrors = res.data.Data || []
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        clearForm(){
            this.uploadObject.File = null
            this.uploadObject.Month = moment().month() + 1
            this.uploadObject.Year = moment().year()
        },
        upload(){
            this.clearForm()
            this.$showModal('upload')
        },
        provider(data){
            return EmployeeOperationsApi.Bes.Table({
                PaginateRequest:data,
                ...this.filterData
            })
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1980
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
    }
}
</script>